import React, { useState, useRef, useEffect } from 'react'
import { makeStyles, Box, Chip, useTheme, fade, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useImageTranslation } from 'src/hooks'
import { productClick, selectItem } from 'src/utils/trackingCode'
import translationHK from 'src/assets/locales/zh-HK/translation.json'

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    overflowX: 'scroll',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    justifyContent: 'space-between',
    // scrollBehavior: 'smooth',
    cursor: 'pointer',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  swiperSlide: {
    flexShrink: 0,
    borderRadius: theme.spacing(3),
    width: theme.spacing(50),
    background: '#fff',
    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(33),
    },
  },
  productCard: {
    flexShrink: 0,
    width: '100%',
    height: '270px',
    borderRadius: '24px 24px 0 0',
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },
  },
  swiperSlideImgBox: {
    textAlign: 'left',
    // width: theme.spacing(27.5),
    fontWeight: 600,
    fontSize: 20,
    color: fade(theme.palette.common.black),
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      width: theme.spacing(27.5),
    },
  },

  swiperSlideChipBox: {
    textAlign: 'left',
    borderRadius: 100,
    position: 'absolute',
    bottom: 18,
    [theme.breakpoints.down('xs')]: {
      bottom: 16,
    },
  },
  swiperSlideChip: {
    borderRadius: theme.spacing(12.5),
    backgroundColor: '#F3F4F6',
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      maxWidth: 240,
    },
  },
}))

function HorizontalCardList(data) {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const history = useHistory()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [productCard, setProductCard] = useState([])
  const productCard1 = [
    {
      index: 1,
      img: tImage('cancer_3x2', 'webp'),
      name: t('form.cancer'),
      nameInclude: true,
      intro: t('productPage.NPC.first_website_card_intro.2'),
      price: 'HKD3,500',
      path: '/product-cancer-screening',
      promotion: t('form.health_check.promotion'),
      id: 'EH_ProductInfo_CancerScreening_InfoCard',
      package: 2,
      discountprice: 330,
      nameHK: translationHK?.form?.cancer
    },
    {
      index: 0,
      img: tImage('Prophecy_3x2', 'webp'),
      name: t('glossary.prophecy'),
      nameInclude: false,
      intro: t('productPage.NPC.first_website_card_intro.1'),
      price: 'HKD2,200',
      path: '/product-prophecy',
      promotion: t('form.health_check.promotion'),
      id: 'EH_ProductInfo_Prophecy_InfoCard',
      package: 1,
      discountprice: 330,
      nameHK: translationHK?.glossary?.prophecy
    },
    {
      index: 2,
      img: tImage('health_check_female_3x2', 'webp'),
      name: t('glossary.physical_examination_female'),
      nameInclude: true,
      intro: t('productPage.NPC.first_website_card_intro.1'),
      price: 'HKD4,300',
      path: '/product-female-health-check-package',
      promotion: t('form.health_check.promotion'),
      id: 'EH_ProductInfo_Prophecy_InfoCard_Female',
      package: 5,
      discountprice: 330,
      nameHK: translationHK?.glossary?.physical_examination_female
    },
    {
      index: 3,
      // img: tImage('product_NPC', 'webp'),
      img: tImage('health_check_male_3x2', 'webp'),
      name: t('glossary.physical_examination_male'),
      nameInclude: true,
      intro: t('productPage.NPC.first_website_card_intro.1'),
      price: 'HKD4,300',
      path: '/product-male-health-check-package',
      promotion: t('form.health_check.promotion'),
      id: 'EH_ProductInfo_Prophecy_InfoCard_Male',
      package: 4,
      discountprice: 330,
      nameHK: translationHK?.glossary?.physical_examination_male
    },
    {
      index: 4,
      // img: tImage('product_NPC', 'webp'),
      img: tImage('health_check_3x2', 'webp'),
      name: t('form.physical_examination_basic'),
      nameInclude: true,
      intro: t('productPage.NPC.first_website_card_intro.1'),
      price: 'HKD4,000',
      path: '/product-standard-health-check-package',
      promotion: t('form.health_check.promotion'),
      id: 'EH_ProductInfo_Prophecy_InfoCard_All',
      package: 3,
      discountprice: 330,
      nameHK: translationHK?.form?.physical_examination_basic
    },
  ]
  const cardContainerRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)
  const [dragStartX, setDragStartX] = useState(null)
  const [scrollLeftStart, setScrollLeftStart] = useState(null)

  const handleMouseDown = (e) => {
    setIsDragging(true)
    setDragStartX(e.pageX)
    setScrollLeftStart(cardContainerRef.current.scrollLeft)
  }

  const handleMouseMove = (e) => {
    if (!isDragging) {
      return
    }
    const dragOffset = e.pageX - dragStartX
    cardContainerRef.current.scrollLeft = scrollLeftStart - dragOffset
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }
  useEffect(() => {
    const productCard2 = [...productCard1]
    if (data.data === '1') {
      productCard2.splice(1, 1)
    }
    if (data.data === '2') {
      productCard2.splice(0, 1)
    }
    if (data.data === 5) {
      productCard2.splice(2, 1)
    }
    if (data.data === 4) {
      productCard2.splice(3, 1)
    }
    if (data.data === 3) {
      productCard2.splice(4, 1)
    }
    setProductCard(productCard2)
  }, [data.data !== ''])
  return (
    <div
      className={classes.cardContainer}
      ref={cardContainerRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      {productCard.map((item, index) => (
        <Box
          key={index}
          className={classes.swiperSlide}
          border=" 1px solid #D9D9D9"
          textAlign="center"
          display="flex"
          flexDirection="column"
          // justifyContent="space-between"
          height={isMobile ? 339 : 470}
          position="relative"
          pb={3}
          id={item.id}
          mx={1}
          onClick={() => {
            if(data.data && data.data !== ''){
              selectItem('related_product', 'Related Product', item, item?.index )
            } else {
              productClick('EH_HP_product', 'EH_HP_product', item.nameHK, item.path )
              selectItem('product_list', 'Product List', item, item?.index)
            }
            history.push(`/${i18n.language}${item.path}`)
          }}
        >
          <Box>
            <img className={classes.productCard} src={item.img} alt="product info banner" />
          </Box>
          <Box ml={isMobile ? 1.5 : 3}>
            <Box className={classes.swiperSlideImgBox} py={1.5} whiteSpace="break-spaces">
              {item.name}
            </Box>
            {item.nameInclude ? (
              <Box textAlign="left" color="#4B5563" mb={1.5} mt={-0.5} fontSize={isMobile ? 14 : 16}>
                {t('glossary.included_Take2Prophecy')}
              </Box>
            ) : (
              ''
            )}
            <Box
              fontWeight={600}
              color="secondary.main"
              textAlign="left"
              fontSize={isMobile ? 16 : 20}

              // mt={index === 1 && i18n.language !== 'en' ? 1.7 : 0}
            >
              {item.price}
            </Box>
            <Box className={classes.swiperSlideChipBox}>
              <Chip
                className={classes.swiperSlideChip}
                label={t('glossary.discount', { field: item.discountprice })}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </div>
  )
}

export default HorizontalCardList
